<template>
    <div class="page">
        <div class="page-bd">
            <Button type="primary" @click="openAddDep">{{$t("add_dep")}}</Button>
            <Button type="primary" @click="list()">{{$t("rfs")}}</Button>
            <div class="tree-box">
                <div v-for="item in listData" :key="item.dep_id">
                    <span><Icon class="left-icon" type="ios-arrow-down" />{{item.dep_cname}}
                        <span class="tag error fr" @click="delDep(item.dep_id)">{{$t("del")}}</span>
                        <span class="tag primary fr" @click="openSave(item)">{{$t("info")}}</span>
                        <span class="tag primary fr" @click="openAddUser(item.dep_cname, item.dep_id)">{{$t("add_role_user")}}</span>
                    </span>
                    <div class="sub-tree c1" v-for="item2 in item.users" :key="item2.u_id">
                        <span><Icon class="left-icon f-green2" type="md-contact" />{{item2.user_cname}}
                            <span class="user-code-font">({{item2.user_code}})</span>
                            <span class="tag error" @click="removeUser(item.dep_id, item2.u_id)">{{$t("remove")}}</span>
                        </span>
                        <div class="sub-tree c2" v-for="item3 in item2.roles" :key="item3.role_id">
                            <span><Icon class="left-icon f-yellow" type="ios-ribbon" />{{item3.role_cname}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myNav from "../../../components/myNav"
    import myToolbar from '../../../components/myToolbar'
    import myNodata from '../../../components/myNodata'
    export default {
        name:"org-dep",
        components:{
            myNav,
            myToolbar,
            myNodata,
        },
        data:function(){
            return{
                title: this.$t('dep'),
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url:'dep/list'
                },
                listData: [],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openAddDep:function () {
                this.sub_title = this.title;
                this.$base.linkTo("/org/dep/save");
            },
            openAddUser:function (dep_cname, id) {
                var title = this.$t("add_role_user");;
                this.sub_title = title;
                this.$base.linkTo("/org/dep/user",{id, dep_cname});
            },
            openSave:function (item) {
                this.sub_title = this.$t("upd") + item.dep_cname;
                this.$base.linkTo("/org/dep/save",{data: JSON.stringify(item)});
            },
            delDep: function (dep_id) {
                let data = {
                    dep_id: dep_id
                };

                let content = this.$t('confirm_delete');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("dep/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                },()=>{})
            },
            removeUser: function (dep_id, u_id) {
                let data = {
                    u_id: u_id,
                    dep_id: dep_id
                };
                let content = this.$t('confirm_delete');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("dep/del-user",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);

                        }
                    });
                },()=>{})
            },
        },

        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/dep/dep.vue